const labelVersion = idx => {
  return `V${parseInt(idx + 1, 10)
    .toString()
    .padStart(2, '0')}`;
};

export default labelVersion;
